import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAgentPanelMinimized.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export const useTrackAgentPanelMinimized = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentPanelMinimized = useCallback(() => {
    track(META.name, withWorkspaceAgentCategory({}));
  }, [track]);

  return { trackAgentPanelMinimized };
};
